import { render } from "./BuyGetFree.vue?vue&type=template&id=d486b51c&scoped=true"
import script from "./BuyGetFree.vue?vue&type=script&lang=js"
export * from "./BuyGetFree.vue?vue&type=script&lang=js"

import "./BuyGetFree.vue?vue&type=style&index=0&id=d486b51c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d486b51c"]])

export default __exports__